module.exports = {
  hypernovaWrapperClassName: '_hy',
};
